import AWS from 'aws-sdk/global'

export const identityPoolId = process.env.REACT_APP_IDENTITY_POOL_ID || 'eu-west-1:802f3fb3-af35-4d58-8e0b-a2d4979fece0'
export const region = process.env.REACT_APP_REGION || 'eu-west-1'

AWS.config.region = region
